<app-gridbotcreate *ngIf="orderStep == 'one'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)"></app-gridbotcreate>
<app-gridbotpreview *ngIf="orderStep == 'two'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)" [orderPlaceDet]="orderPlaceDet"></app-gridbotpreview>
<app-gridbotdetails *ngIf="orderStep == 'three'" orderStep="orderStep" [botDetails]="botDetails"></app-gridbotdetails>
<app-gridbotstop *ngIf="orderStep == 'four'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)"></app-gridbotstop>
